module.exports = __webpack_public_path__ + "static/media/ppt-simple-icon.46bf9bef.svg";